import React from "react";
import { McqQuestion } from "./McqQuestion";
import {
  ICP_TYPES, ICP_SIZES, SECTORS, DECIDER_PROFILES, BUYING_TRIGGERS,
  CLIENT_PROBLEMS, CLIENT_BUDGETS, URGENCY_LEVELS, CHOICE_CRITERIA,
} from "./constants";

/** Step 3 — Client idéal (9 MCQ) */
export function StepICP({ form, up }) {
  return (
    <div className="space-y-5">
      <div className="rounded-xl px-5 py-4 border border-emerald-500/30 bg-emerald-500/10">
        <p className="hp-label mb-1" style={{ color: "#86efac" }}>
          9 questions · environ 2 min
        </p>
        <p className="text-sm text-zinc-300 leading-relaxed">
          Décrivez le client que Prosperr doit vous ramener. Plus vous êtes précis, plus la prospection sera ciblée.
        </p>
      </div>

      <McqQuestion
        title="1. Quel type de structure visez-vous ?"
        mode="multi"
        options={ICP_TYPES}
        value={form.icp_types}
        onChange={(v) => up("icp_types", v)}
        testidPrefix="q-icp-type"
      />
      <McqQuestion
        title="2. Quelle taille d'entreprise ciblez-vous ?"
        mode="multi"
        options={ICP_SIZES}
        value={form.icp_sizes}
        onChange={(v) => up("icp_sizes", v)}
        testidPrefix="q-icp-size"
        columns={1}
      />
      <McqQuestion
        title="3. Dans quels secteurs ?"
        subtitle="Cochez jusqu'à 5 secteurs prioritaires."
        mode="multi"
        maxSelect={5}
        options={SECTORS}
        value={form.icp_sectors}
        onChange={(v) => up("icp_sectors", v)}
        testidPrefix="q-icp-sector"
      />
      <McqQuestion
        title="4. Quel est le profil de votre décideur ?"
        subtitle="Qui signe le devis ou la commande ?"
        mode="multi"
        options={DECIDER_PROFILES}
        value={form.decider_profiles}
        onChange={(v) => up("decider_profiles", v)}
        testidPrefix="q-decider"
      />
      <McqQuestion
        title="5. Quels événements déclenchent leur besoin ?"
        subtitle="Prosperr s'en servira pour détecter les signaux d'achat en ligne."
        mode="multi"
        options={BUYING_TRIGGERS}
        value={form.buying_triggers}
        onChange={(v) => up("buying_triggers", v)}
        testidPrefix="q-trigger"
      />
      <McqQuestion
        title="6. Quels problèmes veulent-ils résoudre ?"
        mode="multi"
        options={CLIENT_PROBLEMS}
        value={form.client_problems}
        onChange={(v) => up("client_problems", v)}
        testidPrefix="q-problem"
      />
      <McqQuestion
        title="7. Quel budget habituel allouent-ils ?"
        mode="single"
        options={CLIENT_BUDGETS}
        value={form.client_budget}
        onChange={(v) => up("client_budget", v)}
        testidPrefix="q-budget"
        columns={1}
      />
      <McqQuestion
        title="8. Quelle est l'urgence de leur besoin ?"
        mode="single"
        options={URGENCY_LEVELS}
        value={form.urgency_level}
        onChange={(v) => up("urgency_level", v)}
        testidPrefix="q-urgency"
      />
      <McqQuestion
        title="9. Quel est leur critère de choix n°1 ?"
        mode="single"
        options={CHOICE_CRITERIA}
        value={form.choice_criterion}
        onChange={(v) => up("choice_criterion", v)}
        testidPrefix="q-criterion"
      />
    </div>
  );
}
